// types
import { PaletteThemeProps } from '@assetron/common/types/theme';
import { PaletteColorOptions } from '@mui/material/styles';

// colors
import {
  BRAND_COLORS,
  CALENDULA_GOLD_COLORS,
  CYAN_COLORS,
  DUST_RED_COLORS,
  ERROR_COLORS,
  GREY_COLORS,
  POLAR_GREEN_COLORS,
  SUCCESS_COLORS,
  SUNSET_ORANGE,
  VOLCANO_COLORS,
  WARNING_COLORS,
} from '@assetron/common/constants/colors';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Default(): PaletteThemeProps {
  const greyColors: PaletteColorOptions = GREY_COLORS;
  const sunsetOrangeColors: PaletteColorOptions = SUNSET_ORANGE;
  const brandColors: PaletteColorOptions = BRAND_COLORS;
  const volcanoColors: PaletteColorOptions = VOLCANO_COLORS;
  const cyanColors: PaletteColorOptions = CYAN_COLORS;
  const dustRedColors: PaletteColorOptions = DUST_RED_COLORS;
  const calendulaGoldColors: PaletteColorOptions = CALENDULA_GOLD_COLORS;
  const polarGreenColors: PaletteColorOptions = POLAR_GREEN_COLORS;
  const contrastText = '#fff';

  return {
    primary: {
      ...BRAND_COLORS,
      main: BRAND_COLORS[600],
      contrastText,
    },
    secondary: {
      ...CYAN_COLORS,
      main: CYAN_COLORS[700],
      contrastText,
    },
    info: {
      ...GREY_COLORS,
      main: GREY_COLORS[500],
      contrastText,
    },
    error: {
      ...ERROR_COLORS,
      contrastText,
    },
    warning: {
      ...WARNING_COLORS,
      contrastText,
    },
    success: {
      ...SUCCESS_COLORS,
      contrastText,
    },

    grey: greyColors,
    sunsetOrange: sunsetOrangeColors,
    brand: brandColors,
    volcano: volcanoColors,
    cyan: cyanColors,
    dustRed: dustRedColors,
    calendulaGold: calendulaGoldColors,
    polarGreen: polarGreenColors,
  };
}
